import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { MatDialog } from '@angular/material/dialog';
import { ErrorMessageService } from '../services/error-message.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { AuthService } from '../_services/auth.service';
@Component({
  selector: 'app-add-rent-buy',
  templateUrl: './add-rent-buy.component.html',
  styleUrls: ['./add-rent-buy.component.scss']
})
export class AddRentBuyComponent implements OnInit {
  @ViewChild('galleryScroll') galleryScroll!: ElementRef<HTMLDivElement>;
  @ViewChild('emailDialog') emailDialog!: TemplateRef<any>;
  @ViewChild('otpDialog') otpDialog!: TemplateRef<any>;
  @ViewChild('videoGalleryScroll') videoGalleryScroll: ElementRef;

  dialogRef: MatDialogRef<any> | null = null;
  showVideoGallery = false;
  showVideoFullscreen = false;
  videoFullscreenIndex = 0;
  email: string = '';
  otpSent = false;
  enteredOtp: string = '';
  expectedOtp: string = '';
  otpConfig = { length: 6, inputStyles: { width: '40px', height: '40px' } };
  step = 1;
  progress = 0;
  form: FormGroup;
  isSellSelected: boolean = false;
  isresiSelected: boolean = false;
  isconSelected: boolean = false;
  selectedCityId: string | null = null;
  searchCityQuery: string = 'Gurgaon';
  cityDataList: any[] = [];
  stateList: any[] = [];
  selectedStateId: string | null = null;
  VediouploadedImages: any[] = [];
  VedioselectedFiles: File[] = [];
  VedioselectedFileNames: string[] = [];
  submitted = false;

  VedioimageItems: any[] = [
    {
      constrolName: 'imageUrls',
      purpose: 'propertiesImage',
      index: 0,
      url: '',
      type: 'image',
      controlArray: true,
      loading: false,
      linkadd: false,
    },
  ];
    uploadedImages: any[] = [];
  selectedFiles: File[] = [];
  selectedFileNames: string[] = [];
  imageItems: any[] = [
    {
      constrolName: 'imageUrls',
      purpose: 'propertiesImage',
      index: 0,
      url: '',
      type: 'image',
      controlArray: true,
      loading: false,
      linkadd: false,
    },
  ];
  showGallery = false;
  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef,
    private homeService: HomeService, private router: Router,
    private toastr: ToastrService, private dialog: MatDialog,
    private errorMessageService: ErrorMessageService, private tokenStorage: TokenStorageService,
    private authService: AuthService,

  ) {
  }
  floorOptions = [
    { label: 'Ground Floor', value: 'ground' },
    { label: '1st Floor', value: '1' },
    { label: '2nd Floor', value: '2' },
    { label: '3rd Floor', value: '3' },
    { label: '4th Floor', value: '4' },
    { label: '5th Floor', value: '5' },
    { label: '6th Floor', value: '6' },
    { label: '7th Floor', value: '7' },
    { label: '8th Floor', value: '8' },
    { label: '9th Floor', value: '9' },
    { label: '10th Floor', value: '10' }

  ];

  waterSupplyOptions = [
    { label: '24 Hour', value: '24hour' },
    { label: '2 to 12 Hour', value: '2to12hour' }
  ];
  ageOptions = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4+', value: '4plus' }
  ];
  onOfferChange() {
    const offerValue = this.form.get('postType')?.value;
    this.isSellSelected = offerValue === 'Sell';
  }

  resitype() {
    const offerValue = this.form.get('type')?.value;
    this.isresiSelected = offerValue === 'Commercial';
  }
  condition() {
    const conditionvalue = this.form.get('condition')?.value;
    this.isconSelected = conditionvalue === 'Unfurnished';
  }

  getConicGradient(): string {
    const progress = Math.max(this.progress);
    return `conic-gradient(#004aad ${progress}%, #d9d9d9 ${progress}% 100%)`;
  }


  get amenitiesArray(): FormArray {
    return this.form.get('amenities') as FormArray;
  }

  onAmenityChange(event: any): void {
    const amenities: FormArray = this.amenitiesArray;
    if (event.target.checked) {
      amenities.push(this.fb.control(event.target.value));
    } else {
      const index = amenities.controls.findIndex(x => x.value === event.target.value);
      if (index >= 0) {
        amenities.removeAt(index);
      }
    }
  }
  stepFieldMap: { [key: number]: string[] } = {
    1: ['postType', 'type', 'furnishing', 'propertyType', 'amenities'],
    2: ['title', 'description', 'buildupArea', 'waterSource', 'construction', 'coverArea', 'widthOfFacingRoadUnit'],
    3: ['address', 'cityId', 'stateId', 'area', 'propertyRentPrice', 'maintenanceCharge'],
    4: ['imageUrls', 'videoUrls']
  };

  ngOnInit(): void {
    this.searchCity();
    this.initializeForm();
    this.form.valueChanges.subscribe(() => {
      this.updateProgress();
    });
  }
updateProgress() {
  let completedSteps = 0;

  for (const step in this.stepFieldMap) {
    const fields = this.stepFieldMap[step];
    if (fields.length === 0) continue;

    const allValid = fields.every(field => {
      const control = this.form.get(field);

      if (!control || !control.valid || control.value === null || control.value === '') {
        return false;
      }

      // Check for FormArray (e.g., amenities) not empty
      if (control instanceof FormArray && control.length === 0) {
        return false;
      }

      return true;
    });



    if (allValid) {
      completedSteps++;
    }
  }

  const totalSteps = Object.keys(this.stepFieldMap).length;
  this.progress = (completedSteps / totalSteps) * 100;
}


  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ''); // Remove any non-digit characters
    if (input.value.length > 6) {
      input.value = input.value.slice(0, 6); // Limit to 10 digits
    }
  }
  initializeForm() {
    this.form = this.fb.group({
      // firstformpostType
      postType: ['Rent', Validators.required],
      type: ['Residential', Validators.required],
      furnishing: ['Furnished', Validators.required],
      propertyType: ['', Validators.required],
      amenities: this.fb.array([]),

      // secondform

      title: ['', Validators.required],
      status: ['draft'],
      totalFloors: [this.floorOptions[0].value],
      waterSource: [this.waterSupplyOptions[0].value],
      construction: [this.ageOptions[0].value],
      description: ['', Validators.required],
      buildupArea: ['', Validators.required],
      coverArea: ['', Validators.required],
      widthOfFacingRoadUnit: [],

      // thirdform
      propertyRentPrice: ['', Validators.required],
      asking: [],
      maintenanceCharge: ['', Validators.required],
      cityId: ['', Validators.required],
      cityName: [''],
      stateId: ['', Validators.required],
      area: ['', Validators.required],
      address: ['', Validators.required],


      // thirdform
      imageUrls: [''],
      videoUrls: ['']
    });
  }

  nextStep() {
    const stepFieldMap: { [key: number]: string[] } = {
      1: ['postType', 'type', 'furnishing', 'propertyType'],
      2: ['title', 'description', 'buildupArea', 'coverArea'],
      3: ['address', 'cityId', 'stateId', 'area'],
      4: []
    };

    const currentFields = stepFieldMap[this.step] || [];

    for (let field of currentFields) {
      const control = this.form.get(field);
      control?.markAsTouched();
      control?.updateValueAndValidity();

      if (!control || !control.valid) {
        Swal.fire({
          icon: 'warning',
          title: 'Warning',
          text: 'Please fill all required fields',
          timer: 1200,
          timerProgressBar: true,
          showConfirmButton: false
        });
        return;
      }
    }

    if (this.step < 4) {
      this.step++;
      this.updateProgress();
      this.cdr.detectChanges();
    }
  }

  // Helper to format field names (e.g. 'buildupArea' → 'Buildup Area')
  formatFieldName(field: string): string {
    return field
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase());
  }






  prevStep() {
    if (this.step > 1) {
      this.step--;
      this.updateProgress();
      this.cdr.detectChanges();
    }
  }

  submit() {
    const token = localStorage.getItem('access_token');
    if (!token) {
      this.openEmailDialog();
      return;
    }

    const payload = {
      ...this.form.value,
      imageUrls: this.uploadedImages,
      videoUrls: this.VediouploadedImages
    };

    console.log('Form Payload:', payload);
    this.AddProperty(payload);
  }



  AddProperty(payload, token?: string) {
    this.homeService.CreateProperty(payload, token).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          // Save values to localStorage
          localStorage.setItem('allcityId', response.payload?.cityId);
          localStorage.setItem('allstateId', response.payload?.stateId);
          localStorage.setItem('selectedCityName', response.payload?.cityName);
          localStorage.setItem('selectedCityId', response.payload?.cityId);
          this.form.reset();
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Property Added Successfully',
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false
          })
            .then(() => {
              this.router.navigate(['/UserProperty']).then(() => {
                window.location.reload();
              });
            });
        }
      },
      (error) => {
        console.error('Failed to fetch cities', error);
      }
    );
  }


  onSearchCity(event: { term: string }) {
    const searchTerm = event.term || '';
    this.searchCity(searchTerm);
  }

  searchCity(searchTerm: string = '') {
    if (this.selectedCityId) {
      this.selectedCityId = null;
      this.searchCityQuery = searchTerm;
    }

    this.homeService.searchCity(searchTerm).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.cityDataList = response.payload;

        }
      },
      (error) => {
        console.error('Failed to fetch cities', error);
      }
    );
  }

  onCitySelected(selectedCity: any) {
    console.log('Selected city object:', selectedCity);
    if (selectedCity && selectedCity.id) {
      this.stateList = [{
        stateId: selectedCity.stateId,
        stateName: selectedCity.stateName
      }];
      this.form.patchValue({
        cityId: selectedCity.id,
        cityName: selectedCity.name,
        stateId: selectedCity.stateId
      });
    } else {
      console.warn('Invalid city object selected:', selectedCity);
    }
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }
  handleChange(event: any): void {
    const files = event.target.files;
    if (files && files.length) {
      for (let i = 0; i < files.length; i++) {
        this.selectedFiles.push(files[i]);
        this.selectedFileNames.push(files[i].name);
        this.imageItems.push({ loading: true, purpose: 'propertiesImage' });
      }
      this.cdr.detectChanges();
      this.uploadFiles();
    }
  }

  uploadFiles(): void {
    if (this.selectedFiles.length) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const selectedFile = this.selectedFiles[i];
        const type = this.imageItems[i];
        const mimeType = selectedFile.type;
        const purpose = type.purpose;

        // Set loading true before upload starts
        this.imageItems[i].loading = true;

        this.homeService.getMediaData(purpose, mimeType, selectedFile)
          .pipe(finalize(() => {
            this.imageItems[i].loading = false;
            this.cdr.detectChanges();
            this.updateProgress();

          }))
          .subscribe((res: any) => {
            // Assuming res.url contains uploaded file URL
            this.uploadedImages.push(res.url);
            this.updateProgress();
            this.cdr.detectChanges();
          });
      }

      // Clear the file input and reset selected files and names after upload start
      this.clearFileInput();
    }
  }


  clearFileInput(): void {
    this.selectedFiles = [];
    this.selectedFileNames = [];
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.value = ''; // Clear the file input value
    this.cdr.detectChanges();
  }

  removeImage(index: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Remove this Image from your list?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.uploadedImages.splice(index, 1);
        this.selectedFiles.splice(index, 1);
        this.selectedFileNames.splice(index, 1);
        this.imageItems.splice(index, 1);

        // If last image was removed, switch to upload UI
        if (this.uploadedImages.length === 0) {
          this.showGallery = false;
        }

        this.cdr.detectChanges();

        // Swal.fire({
        //   icon: 'success',
        //   title: 'Image Removed',
        //   showConfirmButton: false,
        //   timer: 1000
        // });
      }
    });
  }





  VediotriggerFileInput(): void {
    const fileInput = document.getElementById('vediofileInput') as HTMLInputElement;
    fileInput.click();
  }
  VediohandleChange(event: any): void {
    const files = event.target.files;
    if (files && files.length) {
      for (let i = 0; i < files.length; i++) {
        this.VedioselectedFiles.push(files[i]);
        this.VedioselectedFileNames.push(files[i].name);
        this.VedioimageItems.push({ loading: true, purpose: 'propertiesImage' });
      }

      this.cdr.detectChanges();
      this.VediouploadFiles();
    }
  }

  VediouploadFiles(): void {
    if (this.VedioselectedFiles.length) {
      for (let i = 0; i < this.VedioselectedFiles.length; i++) {
        const selectedFile = this.VedioselectedFiles[i];
        const item = this.VedioimageItems[i];
        const mimeType = selectedFile.type;
        const purpose = item.purpose;

        // Set loading true before upload starts
        this.VedioimageItems[i].loading = true;

        this.homeService.getMediaData(purpose, mimeType, selectedFile)
          .pipe(finalize(() => {
            this.VedioimageItems[i].loading = false;
            this.updateProgress();

            this.cdr.detectChanges();
          }))
          .subscribe((res: any) => {
            this.VediouploadedImages.push(res.url);
            this.updateProgress();
            this.cdr.detectChanges();
          });
      }

      // Clear input and reset selections
      this.VedioclearFileInput();
    }
  }



  VedioclearFileInput(): void {
    this.VedioselectedFiles = [];
    this.VedioselectedFileNames = [];
    const fileInput = document.getElementById('vediofileInput') as HTMLInputElement;
    fileInput.value = ''; // Clear the file input value
    this.cdr.detectChanges();
  }

  VedioremoveImage(index: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Remove this Video from your list?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.VediouploadedImages.splice(index, 1);
        this.VedioselectedFiles.splice(index, 1);
        this.VedioselectedFileNames.splice(index, 1);
        this.VedioimageItems.splice(index, 1);

        // If last video was removed, close gallery or show upload UI
        if (this.VediouploadedImages.length === 0) {
          this.showVideoGallery = false; // Make sure you define and use this flag in your component
        }

        this.cdr.detectChanges();

      }
    });
  }



  scrollGallery(direction: number) {
    const container = this.galleryScroll.nativeElement;
    const scrollAmount = 150;
    container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }
  showFullscreen = false;
  fullscreenIndex = 0;
  prevFullscreenImage() {
    if (this.fullscreenIndex > 0) {
      this.fullscreenIndex--;
    }
  }
  openFullscreen(index: number) {
    this.fullscreenIndex = index;
    this.showFullscreen = true;
  }

  closeFullscreen() {
    this.showFullscreen = false;
  }
  nextFullscreenImage() {
    if (this.fullscreenIndex < this.uploadedImages.length - 1) {
      this.fullscreenIndex++;
    }
  }



  scrollVideoGallery(direction: number) {
    const container = this.videoGalleryScroll?.nativeElement;
    if (container) {
      container.scrollLeft += direction * 220; // Adjust scroll value as needed
    }
  }

  openVideoFullscreen(index: number) {
    this.videoFullscreenIndex = index;
    this.showVideoFullscreen = true;
  }

  closeVideoFullscreen() {
    this.showVideoFullscreen = false;
  }

  prevFullscreenVideo() {
    if (this.videoFullscreenIndex > 0) {
      this.videoFullscreenIndex--;
    }
  }

  nextFullscreenVideo() {
    if (this.videoFullscreenIndex < this.VediouploadedImages.length - 1) {
      this.videoFullscreenIndex++;
    }
  }


  onOtpChange(otp: string) {
    this.enteredOtp = otp;
  }
  openEmailDialog() {
    this.email = '';
    this.dialogRef = this.dialog.open(this.emailDialog, {
      width: '450px',
      disableClose: true
    });
  }

  sendOtp() {
    if (!this.email) {
      this.submitted = true;
      return;
    }
    this.sendemail(this.email)
  }
  sendemail(email) {
    this.homeService.sendemail(this.email).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.toastr.success('Sent OTP Successfully', 'Success');
          this.dialogRef?.close();
          this.openOtpDialog();
        } else if (response['message']) {
          let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
          this.toastr.error(errorMessage, 'Error');
        }
      },
      (error) => {
        const errorMessage = 'An error occurred during OTP verification.';
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }
  openOtpDialog() {
    this.enteredOtp = '';
    this.dialogRef = this.dialog.open(this.otpDialog, {
      width: '450px',
      disableClose: true
    });
  }

  verifySubmit() {
    if (this.enteredOtp) {
      this.homeService.verifyOtpsignup(this.email, this.enteredOtp).subscribe(
        (response: any) => {
          if (response.status === 'SUCCESS') {
            this.dialogRef?.close();

            let accessT = response.payload.access_token;
            const accessToken = response.payload;
            this.tokenStorage.saveToken(JSON.stringify(accessToken));
            const refreshToken = response.payload.refresh_token;
            const expiresIn = response.payload.expires_in;

            localStorage.setItem("access_token", accessT);
            localStorage.setItem("refresh_token", refreshToken);
            localStorage.setItem("expires_in", expiresIn);

            this.tokenStorage.saveSocialOrigin(null);
            this.tokenStorage.saveSocialUserEmail(null);
            this.tokenStorage.saveFirstVisitToHomePageAfterLogin("firstVisit");

            const payload = {
              ...this.form.value,
              imageUrls: this.uploadedImages,
              videoUrls: this.VediouploadedImages
            };

            console.log('Form Payload:', payload);
            this.AddProperty(payload, accessT);
            this.profiledata()
            // Fetch and store user profile

          } else if (response['message']) {
            let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
            this.toastr.error(errorMessage, 'Error');
          }
        },
        (error) => {
          const errorMessage = 'An error occurred during OTP verification.';
          this.toastr.error(errorMessage, 'Error');
        }
      );
    } else {
      const errorMessage = 'An error occurred during OTP verification.';
      this.toastr.error(errorMessage, 'Error');
    }
  }
  profiledata() {
    this.authService.getProfileData().subscribe(
      (profileData: any) => {
        let UserProfile = profileData;
        localStorage.setItem("UserProfile", JSON.stringify(UserProfile));
        console.log("UserProfile retrieved and stored successfully");
      },
      (error) => {
        console.error("Failed to retrieve user profile", error);
      }
    );
  }

}
